import intl from 'react-intl-universal'

const keys = [
  'header',
  'text',
  'blockquote',
  'quote2',
  'image',
  'gallery',
  'video',
  'raw_html',
  'interstitial_link',
  'reference',
  'list',
  'link_list',
  'table',
  'code',
  'correction',
  'quote',
  'numeric_rating',
  'divider',
]

export default keys.map((key) => ({
  key,
  text: intl.get(`settings.toolboxOptions.${key}`),
  default: true,
}))
